import { useState } from "react";
import AddBoostToOrderModelContainer, {
    TSelectedRows,
} from "../AddBoostToOrderModel/AddBoostToOrderModelContainer";
import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";

export interface AddBoostToOrderModelWithButtonProps {
    selectedRows?: TSelectedRows[] | null;
    handlerValueToUpdateGrid?(update: boolean): void;
}
const AddBoostToOrderModelWithButton = (props: AddBoostToOrderModelWithButtonProps) => {
    const { selectedRows, handlerValueToUpdateGrid = () => {} } = props;
    const { formatMessage } = useIntl();
    const [showBoostModal, setShowBoostModel] = useState(false);

    return (
        <>
            {selectedRows && selectedRows.length > 0 && (
                <>
                    <Button
                        onClick={() => {
                            setShowBoostModel(true);
                        }}
                    >
                        {formatMessage({ id: "common.action.AddBoostToOrders" })}
                    </Button>

                    {showBoostModal && (
                        <AddBoostToOrderModelContainer
                            selectedRows={selectedRows}
                            handlerValueToUpdateGrid={handlerValueToUpdateGrid}
                            handleClose={() => setShowBoostModel(false)}
                            showModal={showBoostModal}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default AddBoostToOrderModelWithButton;
